import React from "react";
import { Routes, Route } from "react-router-dom";

import OnboardingScreen from "./OnboardingScreen";
import SuccessScreen from "./SuccessScreen";
import ExistingUserScreen from "./ExistingUserScreen";

const OnboardingRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<OnboardingScreen />} />
      <Route path="/success" element={<SuccessScreen />} />
      <Route path="/existing-user" element={<ExistingUserScreen />} />
    </Routes>
  );
};

export default OnboardingRoutes;
